import type { Filters } from './types';

export const DEFAULT_FILTERS: Filters = {
  minSpend: null,
  maxSpend: null,
  minOrders: null,
  maxOrders: null,
  store: '',
  location: '',
  lastOrderDays: null,
};
